import { useAppSelector } from '../store/hooks'
import { selectAccountId } from '../store/auth/authSlice'
import { useGetMeQuery } from '../store/user/user'
import { DEFAULT_TIMEZONE } from '../components/TimezoneSelector/constants'

export function useUserTimezone(): string {
  const accountId = useAppSelector(selectAccountId)
  const { data: currentUser } = useGetMeQuery({ accountId })
  return currentUser?.effectiveSettings?.timezone ?? DEFAULT_TIMEZONE
}
